
  const baseUrl = "https://onboard.rechargkit.biz"; 
  export default baseUrl; 